export default "__VITE_ASSET__DNX5tldG__"